import React, {FC,ReactNode} from 'react'

interface Props {
    children: ReactNode;
}

export const TableRow:FC<Props> = ({children}) => {
  return (
    <tr style={{border:'1px solid #EAECF0'}}>
          {children}
    </tr>
  )
}


